'use client';

import { styled } from '../../styles';
import { Button } from '../Button';
import { Typography } from '../Typography';

export const TourTooltip = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.blue[900],
  padding: theme.spacing(4),
  borderRadius: `${theme.shape.borderRadius * 8}px`,
  color: theme.palette.textWhite,
  maxWidth: '388px',
}));

export const TourStepTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  color: theme.palette?.grey?.['100'],
}));

export const TourStepActions = styled.div(({ theme }) => ({
  direction: theme.direction === 'rtl' ? 'rtl' : 'ltr',
  position: 'fixed',
  zIndex: theme.zIndex.onboardingMenu,
  top: theme.spacing(12),
  right: theme.spacing(15),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),

  ...(theme.direction === 'rtl' && {
    right: 'auto',
    left: theme.spacing(15),
  }),
}));

export const TourStepActionsTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.textWhite,
}));

export const TourTooltipButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.black[0],
  color: theme.palette.stateNormal,
  width: '100%',
  marginTop: theme.spacing(4),

  '&:hover': {
    backgroundColor: theme.palette.black[0],
    color: theme.palette.stateHover,
  },
}));
